export default __webpack_public_path__ + "static/media/JManagedCampaign-bg.dc2d4eee.png";